import React, { type ReactNode } from 'react';

import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';

import { defaultLocale, fetchMessagesForLocale } from './fetch-messages-for-locale';

export const IntlProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
	return (
		<IntlMessagesProvider defaultMessages={defaultLocale} loaderFn={fetchMessagesForLocale}>
			{children}
		</IntlMessagesProvider>
	);
};
